var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{ref:"menu",staticClass:"nav"},[_c('MenuToggle'),_c('AppIcon'),_c('Menu'),_c('AppVersion')],1)}
var staticRenderFns = []

export { render, staticRenderFns }